import { render, staticRenderFns } from "./OverallSalesDetailKpi.vue?vue&type=template&id=0f6d3bc6&scoped=true"
import script from "./OverallSalesDetailKpi.vue?vue&type=script&lang=js"
export * from "./OverallSalesDetailKpi.vue?vue&type=script&lang=js"
import style0 from "./OverallSalesDetailKpi.vue?vue&type=style&index=0&id=0f6d3bc6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f6d3bc6",
  null
  
)

export default component.exports